
export const CardBasicActionType = {
  /**
   * Display an edit button
   */
  EDIT: 'edit',
}
